import { useSelector } from 'react-redux'
import { isAllowed } from 'src/selectors/modules.selector'
import { clientPermissions } from 'src/enums/permissions'

interface PermissionClientSellResponse {
  canCreate: boolean
  canUpdate: boolean
}
export const usePermissionClientSell = (): PermissionClientSellResponse => {
  const canCreate = useSelector(state => isAllowed(state, [clientPermissions.create]))
  const canUpdate = useSelector(state => isAllowed(state, [clientPermissions.update]))

  return {
    canCreate,
    canUpdate,
  }
}
